import { render, staticRenderFns } from "./Slas.vue?vue&type=template&id=7772edd4&"
import script from "./Slas.vue?vue&type=script&lang=js&"
export * from "./Slas.vue?vue&type=script&lang=js&"
import style0 from "./Slas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports